import { useState } from 'react';
import { useSelector } from 'react-redux';
import { NavLink, useHistory } from 'react-router-dom';
import GenericModal from '../../UI/GenericModal';

import styles from './Header.module.css';

const linksWithBackButton = [""]

const Header = (props) => {
  const history = useHistory();

  const [modalShow, setModalShow] = useState(false);
  const [modalAction, setModalAction] = useState();
  const [modalTitle, setModalTitle] = useState();
  const [modalMessage, setModalMessage] = useState();

  const editChecklistId = useSelector(state => state.editChecklistId);

  const modalCloseHandler = () => {
    setModalShow(false)
  }

  const goHomeHandler = () => {
    history.push("/home");
  }

  const goBackHandler = () => {
    console.log('isEditChecklist ', props.isEditChecklist)
    if (props.isEditChecklist) {
      history.push("edit-new-checklist?checklistId=" + editChecklistId)
    } else {
      history.goBack();
    }
  }

  // const loggOffHandler = () => {};

  const modalDataHandler = (title, message, action) => {
    setModalAction(() => action );
    setModalTitle(title);
    setModalMessage(message);
    setModalShow(true);
    
  }

  return (
    <div
      className={`${styles.header} d-flex justify-content-between align-items-center px-3`}
    >
      <div className={styles.width_px_75}>
        <GenericModal
          show={modalShow}
          handleClose={modalCloseHandler}
          action={modalAction}
          title={modalTitle}
          message={modalMessage}
          modalType='confirmation'
        />
      </div>
      <h6 className={`${styles.headerText} fw-bold`}>{props.children}</h6>
      <nav className={`${styles.width_px_75} d-flex justify-content-between`}>
        <span
          className={styles.home}
          onClick={
            props.pageNeedsSave
              ? () =>
                  modalDataHandler(
                    "Go to Home Page",
                    "All unsaved changes will be lost. Continue?",
                    goHomeHandler
                  )
              : () => history.push("/home")
          }
        ></span>
        <span
            className={`${styles.goBack} `}
            onClick={
              props.pageNeedsSave
              ? () =>
                modalDataHandler(
                  "Go Back",
                  "All unsaved changes will be lost. Continue?",
                  goBackHandler
                )
              : () => history.goBack()
            }
          ></span>
        {/* Below code includes Log Off button logic */}
        {/* {!props.isHomepage ? (
          <span
            className={`${styles.goBack} `}
            onClick={
              props.pageNeedsSave
              ? () =>
                modalDataHandler(
                  goBackHandler,
                  "Go Back",
                  "All unsaved changes will be lost. Continue?"
                )
              : () => history.goBack()
            }
          ></span>
        ) : (
          <span className={styles.exit} onClick={() =>
            modalDataHandler(
              loggOffHandler,
              "Log Off",
              "All unsaved changes will be lost. Continue?"
            )}></span>
        )} */}
      </nav>
    </div>
  );
};

export default Header;